var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.externalMenu && _vm.externalMenu.url && _vm.externalMenu.position === 'top')?_c('div',{staticClass:"header"},[_c('ExternalHeader')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }